const PRELOAD_ERROR_RELOAD_KEY = 'vite-preload-error-reload-attempted';

export const registerPreloadErrorReload = (reloadPage: () => void = () => window.location.reload()) => {
  const handlePreloadError = (event: Event) => {
    if (sessionStorage.getItem(PRELOAD_ERROR_RELOAD_KEY)) {
      return;
    }

    sessionStorage.setItem(PRELOAD_ERROR_RELOAD_KEY, 'true');
    event.preventDefault();
    reloadPage();
  };

  window.addEventListener('vite:preloadError', handlePreloadError);

  return () => window.removeEventListener('vite:preloadError', handlePreloadError);
};
